export const FIGMA_PLUGIN_URL =
	'/plugins/servlet/ac/com.figma.jira-add-on/figma-configure#fromIssueView';
export const FIGMA_PLUGIN_URL_STG =
	'/plugins/servlet/ac/com.figma.jira-add-on-dev/figma-configure#fromIssueView';
export const CONTACT_ADMIN_FORM_URL = '/jira/contact-administrator';
